import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "fuyuan_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(KEY);
            if (raw) setItems(JSON.parse(raw));
        } catch { /* ignore */ }
        setLoaded(true);
    }, []);

    useEffect(() => {
        if (!loaded) return;
        try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* ignore */ }
    }, [items, loaded]);

    const add = (product, qty = 1) => {
        setItems((prev) => {
            const existing = prev.find((x) => x.product_id === product.id);
            if (existing) {
                return prev.map((x) => x.product_id === product.id ? { ...x, quantity: Math.min(x.quantity + qty, product.stock) } : x);
            }
            return [...prev, {
                product_id: product.id,
                name: product.name,
                sku: product.sku,
                image_url: product.image_url,
                unit_price: product.unit_price,
                stock: product.stock,
                quantity: Math.min(qty, product.stock),
            }];
        });
    };

    const setQty = (product_id, qty) => {
        setItems((prev) => prev
            .map((x) => x.product_id === product_id ? { ...x, quantity: Math.max(1, Math.min(qty, x.stock)) } : x)
            .filter((x) => x.quantity > 0));
    };

    const remove = (product_id) => setItems((prev) => prev.filter((x) => x.product_id !== product_id));
    const clear = () => setItems([]);

    const count = items.reduce((n, x) => n + x.quantity, 0);
    const subtotal = items.reduce((n, x) => n + x.quantity * x.unit_price, 0);

    return (
        <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    return useContext(CartContext);
}
